import React from "react";
import { Tab, TabList, Tabs } from "@chakra-ui/tabs";
import { Text } from "@chakra-ui/react";

interface Props {
  textList: string[];
  onChange?: (index: number) => void;
  index?: number;
  color?: string;
  selectedColor?: string;
  backgroundColor?: string;
  selectedBackgroundColor?: string;
}

function CommonMultiTabs({
  textList,
  onChange,
  index,
  color = "#6F6F6C",
  selectedColor = "#444444",
  backgroundColor = "#F7F9FA",
  selectedBackgroundColor = "#FFFFFF",
}: Props) {
  return (
    <Tabs variant="unstyled" onChange={onChange} index={index} padding={"1px"}>
      <TabList
        height={"28px"}
        background={backgroundColor}
        borderRadius={"4px"}
        boxShadow={"0 0 0 0.5px #D4D4D1"}
        color={color}
        whiteSpace={"nowrap"}
        overflow={"hidden"}
        padding={"2px"}
      >
        {textList.map((text, index) => (
          <Tab
            key={text + index}
            _selected={{
              color: selectedColor,
              bg: selectedBackgroundColor,
              fontWeight: 600,
              boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.10)",
            }}
            borderRadius={"2px"}
            fontSize={"14px"}
            fontWeight={400}
            paddingX={"8px"}
            width={"100%"}
          >
            <Text>{text}</Text>
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
}

export default CommonMultiTabs;
